module.exports = __webpack_public_path__ + "static/media/illegal navigation.b0ef7941.jpg";